<template>
  <section class="">
    <h2
      class="px-4 pt-12 pb-4 m-auto max-w-3xl text-2xl text-center md:pb-6 lg:pb-12 md:text-3xl xl:text-42 sm-max:mb-4 sm-max:px-4 md-max:pt-8 xl:leading-tight font-ww-medium">
      <div>
        <div>
          <span class="font-bold" v-html="titleBold">
          </span>
        </div>
      </div>
    </h2>

    <div class="grid grid-cols-4 sm-max:grid-cols-2 xl:px-16">
      <nuxt-img v-for="image in images" :key="image.alt" class="object-cover w-full col-span-1"
        style="max-height: 338px;" loading="lazy" width="256" height="338" format="webp" :alt="image.alt"
        :src="image.src" sizes="xs:130px sm:180px md:351px lg:256px xl:256px 2xl:256px" />
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  titleBold: {
    type: String,
    default: 'People All Over the USA Are Loving This Coffee ...'
  },
  images: {
    type: Array,
    default: () => [
      { src: "/assets/images/person-1.jpg", alt: "Happy customer drinking coffee" },
      { src: "/assets/images/person-2.jpg", alt: "Person enjoying Lifeboost coffee" },
      { src: "/assets/images/person-3.jpg", alt: "Smiling customer with coffee cup" },
      { src: "/assets/images/person-4.jpg", alt: "Customer review photo" },
      { src: "/assets/images/person-5.jpg", alt: "Person holding Lifeboost bag" },
      { src: "/assets/images/person-6.jpg", alt: "Happy coffee drinker" },
      { src: "/assets/images/person-7.jpg", alt: "Customer lifestyle shot" },
      { src: "/assets/images/person-8.jpg", alt: "Person with Lifeboost coffee" },
      { src: "/assets/images/person-9.jpg", alt: "Smiling coffee lover" },
      { src: "/assets/images/person-10.jpg", alt: "Customer enjoying morning coffee" },
      { src: "/assets/images/person-11.jpg", alt: "Person with coffee mug" },
      { src: "/assets/images/person-12.jpg", alt: "Happy customer testimonial" },
      { src: "/assets/images/person-13.jpg", alt: "Coffee drinker smiling" },
      { src: "/assets/images/person-14.jpg", alt: "Customer with product" },
      { src: "/assets/images/person-15.jpg", alt: "Person enjoying hot coffee" },
      { src: "/assets/images/person-16.jpg", alt: "Satisfied customer" },
    ],
  },
})

defineBuilderComponent({
  friendlyName: 'Image Grid With Title',
  inputs: [
    {
      name: 'titleBold',
      type: 'richText',
      friendlyName: 'Title',
      defaultValue: 'People All Over the USA Are Loving This Coffee ...',
    },
    {
      name: 'images',
      type: 'list',
      friendlyName: 'Images List',
      subFields: [
        {
          name: 'src',
          type: 'file',
          friendlyName: 'Image',
          allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png', 'webp'],
          required: true,
        },
        {
          name: 'alt',
          type: 'text',
          friendlyName: 'Alt Text',
          required: true,
          defaultValue: 'Happy customer',
        },
      ],
      defaultValue: [
        { src: "/assets/images/person-1.jpg", alt: "Happy customer drinking coffee" },
        { src: "/assets/images/person-2.jpg", alt: "Person enjoying Lifeboost coffee" },
        { src: "/assets/images/person-3.jpg", alt: "Smiling customer with coffee cup" },
        { src: "/assets/images/person-4.jpg", alt: "Customer review photo" },
        { src: "/assets/images/person-5.jpg", alt: "Person holding Lifeboost bag" },
        { src: "/assets/images/person-6.jpg", alt: "Happy coffee drinker" },
        { src: "/assets/images/person-7.jpg", alt: "Customer lifestyle shot" },
        { src: "/assets/images/person-8.jpg", alt: "Person with Lifeboost coffee" },
        { src: "/assets/images/person-9.jpg", alt: "Smiling coffee lover" },
        { src: "/assets/images/person-10.jpg", alt: "Customer enjoying morning coffee" },
        { src: "/assets/images/person-11.jpg", alt: "Person with coffee mug" },
        { src: "/assets/images/person-12.jpg", alt: "Happy customer testimonial" },
        { src: "/assets/images/person-13.jpg", alt: "Coffee drinker smiling" },
        { src: "/assets/images/person-14.jpg", alt: "Customer with product" },
        { src: "/assets/images/person-15.jpg", alt: "Person enjoying hot coffee" },
        { src: "/assets/images/person-16.jpg", alt: "Satisfied customer" },
      ],
    },
  ],
})
</script>